import { useMemo } from 'react';
import Box from '@rsos/components/capstone/base/Box';
import { VOIP, LANDLINE } from '@rsos/constants/locationTypes';
import { EstimatedAddress } from '../styles/common.styles';
import type { IEstimatedAddressLabel } from './EstimatedAddressLabel.types';

const EstimatedAddressLabel = ({
  addressSingleLine,
  classOfService,
  classOfServiceCategory,
  isMostRecent,
  rgAddressProvider,
  singleHistoricLocation,
}: IEstimatedAddressLabel) => {
  const addressLabel = useMemo(() => {
    if (classOfServiceCategory === VOIP) {
      return addressSingleLine
        ? `• Derived from ALI (${classOfService})`
        : `• Reverse-geocoded from lat/long (${classOfService})`;
    } else if (classOfServiceCategory === LANDLINE) {
      return '• Landline Address';
    } else if (!isMostRecent) {
      return `Estimated Address ${
        rgAddressProvider ? `from ${rgAddressProvider}` : ''
      } | VERIFY with caller`;
    } else {
      return null;
    }
  }, [
    addressSingleLine,
    classOfService,
    classOfServiceCategory,
    isMostRecent,
    rgAddressProvider,
  ]);

  if (!addressLabel) return null;

  return (
    <Box horizontal margin={singleHistoricLocation ? '0 16px' : '10px 0 0 0'}>
      <EstimatedAddress data-name="estimated-address">
        {addressLabel}
      </EstimatedAddress>
    </Box>
  );
};

export default EstimatedAddressLabel;
